"use client";

import { FilterCategory as FilterCategoryComponent } from "./filter-category";
import type {
  FilterCategory,
  SelectedFiltersType,
} from "@/lib/services/catalog/catalog-types";

interface FilterSectionProps {
  filterCategories: FilterCategory[];
  selectedFilters: SelectedFiltersType;
  onFilterChange: (category: string, values: string[]) => void;
  onResetCategory: (category: string) => void;
}

export function FilterSection({
  filterCategories,
  selectedFilters,
  onFilterChange,
  onResetCategory,
}: FilterSectionProps) {
  // Tek bir değer değişikliğini işleyecek yardımcı fonksiyon
  const handleSingleFilterChange = (category: string, value: string) => {
    const currentValues = selectedFilters[category] || [];
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value];
    
    onFilterChange(category, newValues);
  };

  return (
    <div className="bg-white rounded-md border border-zinc-200 p-4 shadow-md animate-fade-in filter-section 
    h-full lg:max-h-none overflow-y-auto" style={{ maxHeight: 'calc(100dvh - 104px)' }}>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4">
        {filterCategories.map((category, index) => (
          <FilterCategoryComponent
            key={category.key}
            title={category.title}
            categoryKey={category.key}
            items={category.items}
            selectedValues={selectedFilters[category.key]}
            onFilterChange={handleSingleFilterChange}
            onResetCategory={onResetCategory}
            isLastCategory={index === filterCategories.length - 1}
          />
        ))}
      </div>
    </div>
  );
}
